import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import PropertyProfileAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/PropertyProfileAppIcon';

const PropertyProfileStrategy = {
  previewInfo: {
    name: 'Property profile',
    iconSvg: <PropertyProfileAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Property profile',
    category: 'Track your customers’ equipment history and serial numbers',
    details: (
      <div>
        Build out a comprehensive equipment profile and service history for each property you work on. Profiles
        automatically link to your customer so you know the details like square footage and what equipment is currently
        installed at each job site.
        <br />
        <br />
        Paired with the service history, you&apos;ll know what parts or tools to take before leaving for a job, whether
        it&apos;s better to estimate a repair or a replacement, or simply when it&apos;s time to remind your customer
        that they&apos;re due for a checkup.
        <br />
        <br />
        Property data is jointly accessible by the property owner and the service professional.
      </div>
    ),
    iconSvg: <PropertyProfileAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/peywt0m548?videoFoam=true',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideCard: true,
  },
  supportContacts: [],
};

export default PropertyProfileStrategy;
